
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content-writer/show-notes",
      function () {
        return require("private-next-pages/content-writer/show-notes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content-writer/show-notes"])
      });
    }
  